import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from "luxon";


export class WebUserSettings {

  @JsonProperty()
  username: string | undefined;

  @JsonProperty()
  forceClearCookies: boolean = false;

  @JsonProperty()
  notifActionTypesJs: string[] = [];

  @JsonProperty()
  mailNotification: boolean = false;

  @JsonProperty()
  clearingTeams: string[] = [];
  securityTeams: string[] = [];

  @JsonProperty()
  cookies: string;

  @JsonProperty()
  lastActivityDate?: DateTime;


}
